module.exports = __webpack_public_path__ + "static/media/avatar-svgrepo-com.d77e64c5.svg";